import definitions from "../../../definitions";
import QuestMinigame from "../QuestMinigame";

export default class MinigameDucklingTrain extends QuestMinigame {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._game = null;
        this._enemy = null;
        this._spawnTime = 0;
        this._spawnDelay = 0;
        this._spawnAreas = null;

        this._spawnPositions = [];

        this._npc = null;
        this._allDucklings = [];
        this._ducklingTrain = [];

        this._holdingDuckling = null;
        this._pen = null;

        this._repressEnemyChase = true;

        this.coins = 1;

        this.bgmName = "music_minigame_catch_challenge_loop";
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._ducklingType = metadata.ducklingType;
        this._spawnDelay = Math.max(metadata.spawnDelay);
        this._spawnLimit = Math.max(metadata.spawnLimit);
        this._spawnAreas = metadata.spawnAreas;
        this.coins = metadata.coins;
    }

    /**
     * @param {GameScene} game
     */
    spawnDuckling(game) {
        const mapWidth = game.world.tilemap.width;
        const mapHeight = game.world.tilemap.height;

        const area = this._spawnAreas[this._allDucklings.length % this._spawnAreas.length];
        console.log(area);
        const position = game.world.findSafePosition(
            new PIXI.Point(
                //mapWidth * (this._allDucklings.length % 2 === 0 ? 0.25 : 0.75),
                mapWidth * area.x,
                mapHeight * area.y
                //mapHeight * (Math.floor(this._allDucklings.length / 2) % 2 === 0 ? 0.25 : 0.75)
            ),
            Math.min(mapWidth, mapHeight) * area.radius, 0, 20, [], 50);
            //(Math.min(mapWidth*0.25, mapHeight*0.25)) * 0.9, 0, 20, [], 50);
        /*
        const circle = new PIXI.Graphics();
        circle.beginFill(0x6b0e33, 0.05);
        circle.drawCircle(
            mapWidth * area.x,
            mapHeight * area.y,
            Math.min(mapWidth, mapHeight) * area.radius
            );
        game.world._tilemap.addChild(circle);*/

        //console.log('spawnDuckling', position);
        const duckling = game.createEnemy(this._ducklingType, position, false, false);
        duckling.target = game.player;
        duckling.state = definitions.ENEMY_STATE.WANDER;
        duckling.signals.grabbed.add(this.onDucklingGrabbed, this);
        
        this._allDucklings.push(duckling);
    }

    /**
     * @param {GameScene} game
     */
    removeAllDucklings(game) {
        for (let i = 0, count = this._allDucklings.length; i < count; ++i) {
            const enemy = this._allDucklings[i];
            game.removeEnemy(enemy);
        }
    }

    /**
     * @param {Enemy} duckling
     */
    onDucklingGrabbed(duckling) {
        //console.log("MOVE To TARGET", duckling.moveToTarget);
        if (duckling.state !== definitions.ENEMY_STATE.WANDER)
            return;
        
        //duckling.interactable = false;
        duckling.state = definitions.ENEMY_STATE.CAPTURE;
        duckling.collisionEnabled = duckling.collisionDynamic = false;
        if (this._ducklingTrain.length === 0)
            duckling.moveToTarget = this._game.player;
        else
            duckling.moveToTarget = this._ducklingTrain[this._ducklingTrain.length-1];
        //console.log("MOVE", duckling.moveToTarget);
        this._ducklingTrain.push(duckling);
        
        this.score++;
        if(this.score >= this._spawnLimit) {
            this._game.completeMinigame(true);
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameStart(game) {
        if (this.isRunning)
            return;

        super.onMinigameStart(game);

        this._npc = game.findNPC(this.owner);
        this._game = game;
    }

    /**
     * @param {GameScene} game
     */
    onMinigameUpdate(game) {
        super.onMinigameUpdate();
        if (this.isRunning) {
            const ducklingCount = this._allDucklings.length;
            if (ducklingCount < this._spawnLimit) {
                if (this._spawnTime > this._spawnDelay) {
                    this._spawnTime = 0;
                    this.spawnDuckling(game);
                }
                this._spawnTime += window.dt;
            }
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameEnd(game) {
        super.onMinigameEnd(game);

        this.removeAllDucklings(game);

        this.bestScore = this.score;
        //console.log("score:", this.score);
    }

    /**
     * @param {GameScene} game
     */
    onMinigameCancel(game) {
        super.onMinigameCancel(game);

        this.removeAllDucklings(game);
    }
}